/*eslint-disable */
import LayerService from '@/services/layers/LayerService';
import store from '@/store/index';
import filter from 'lodash/filter';
import {
  LayerGroup, LeafletEvent, Marker, point, DivIcon, markerClusterGroup,
} from 'leaflet';
import 'leaflet.markercluster';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import { IModalData } from '@/services/layers/IModalData';
import AssetIconService from '@/services/AssetIconService';
import ApiService from '@/services/ApiService';
import { AxiosResponse } from 'axios';
import IPosition from '@/interfaces/IPosition';
import IFeature from '@/interfaces/IFeature';
import { toRaw } from 'vue';
import { IClusterIconSettings, IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';
import MapIconsGeneratorService from '../MapIconsGeneratorService';

export default class CamerasLayerService extends LayerService {
    cameraType = 'fixed';

    onClick = async (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): Promise<void> => {
        
        const title = !!metaData.name ? metaData.name : this.noData;
        let modalIconUrl: string = AssetIconService.getSvgModalIcon(`modal_camera_${this.cameraType}`);
        

        const modalData: IModalData = {
            title: title,
            content: '',
            navigationPoint: undefined,
            lastUpdate: '',
            icon: modalIconUrl,
            templateName: 'TemplateModalCamera',
            metaData: metaData,
        };
      store.commit('displayModal', modalData);
    };

    redrawLayer = (type: string = 'fixed'): LayerGroup<any> => {
        const points: IFeatureCollection = { ...store.state.cameras };

        points.features = filter(
          points.features,
          { properties: { type: type } },
        );
        this.cameraType = type;

        return this.generateMarkerClusterLayer(points);
    };

    protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
      const markerClusterGroupInstance = markerClusterGroup({
        showCoverageOnHover: false,
        maxClusterRadius: 40,
        iconCreateFunction: (cluster) => {
          const population = cluster.getChildCount();
          return new DivIcon({
            html: this.generateClusterHtml(population),
            className: 'custom-cluster-icon',
            iconSize: [this.clusterWidth, this.clusterHeight],
            iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
          });
        },
      });
  
      positions.features.forEach((feature: any) => {
        if (!feature.geometry) return;
  
        const { coordinates } = feature.geometry;
        const [lng, lat] = coordinates as Array<number>;
  
        const singleMarker = this.createMarker({ lat, lng }, feature);
        markerClusterGroupInstance.addLayer(toRaw(singleMarker));
      });
  
      return markerClusterGroupInstance;
    };

    

    generateClusterHtml(population: number) {
        const settings: IClusterIconSettings = {
            className: 'map-cluster--camera',
            insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_camera_fixed.svg`),
            population,
        };
        const iconHtml = MapIconsGeneratorService.getClusterIcon(settings);
        
        return iconHtml;
    };

    protected generateHtmlPointTemplate = (metaData: any): string => {
        const settings: IMarkerIconSettings = {
            className: 'map-marker--camera',
            insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_camera_fixed.svg`),
        };
        const iconHtml = MapIconsGeneratorService.getMarkerIcon(settings);
    
        return iconHtml;
    }
}
